import { Component } from '@angular/core';
import { HeaderTitleService } from '../../../../service/services/misc/header-title/header-title.service';
import { BreadcrumbModel } from '../../../../core/models/misc/breadcrumb.model';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: false
})
export class NotFoundComponent {
    constructor(private _headerTitleService: HeaderTitleService) {
        this._headerTitleService.setTitle(this.generatePageTitle());
    }

    generatePageTitle() {
        let breadcrumbs: BreadcrumbModel[] = [
            {
                text: $localize`:XTIT|Header of the 404 page@@pageHeaders.organizations:Page not found`,
                url: '',
                name: '',
                index: 0,
                path: '',
                loading: false,
                type: null,
                siblings: [],
                isOpen: false,
                totalCount: 0,
                continueToken: ""
            },
        ];
        return breadcrumbs;
    }
}
